/*global chrome */
import React, { useEffect } from "react";
import { Card, Button, Row, Col } from "antd";
import { Content } from "antd/es/layout/layout";
import { useOutletContext } from "react-router-dom";
import ReferralBanner from "../../Components/DashboardComponents/referralBanner";

import "./dashboard.scss";

const ROOT = `dashboard_product`;

const DashboardProducts = (props) => {
  const outletProps = useOutletContext();
  const { colorBgContainer } = outletProps;
  const { headerTitle, setHeaderTitle } = props;

  useEffect(() => {
    // Update the header title when the component mounts
    setHeaderTitle("BAAI Products");
    return () => {
      // Optionally, reset the header title when the component unmounts
      setHeaderTitle("");
    };
  }, [setHeaderTitle]);

  const products = [
    {
      image: "browser-extension",
      heading: "FOCII Browser Extension",
      subHeading: "Content engagement analysis tool for all",
      para: `Engagement AI solution for content platforms that enables content creators to collect engagement insights and optimize their content.`,
      button: "Try Now",
      link: "https://chromewebstore.google.com/detail/focii-youtube/jamlalnkhijfjgbohdakdfgdnidoghca",
    },
    {
      image: "focii",
      heading: "FOCII",
      subHeading:
        "Engagement AI solution to understand audience interest and maximize engagement",
      para: `Gather 1-on-1 insights on individual's interest, and motivation. Get comprehensive understanding of user behavior for targeted engagement strategies. Ensure all boys and girls complete free, equitable and quality primary and secondary education`,
      button: "Coming Soon",
      link: "",
    },
    {
      image: "BA3e",
      heading: "BA3e",
      subHeading: "Everyday wearable for real-time cognitive intelligence",
      para: `BA3e is a cutting edge consumer grade wearable that uses neural activity sensors including electroencephalography(EEG) and functional near-infrared spectroscopy (fNIRS) to decode neural information and help push the boundaries `,
      button: "Coming Soon",
      link: "",
    },
    {
      image: "BA9e",
      heading: "BA9E",
      subHeading: "Wearable for high precision neuroscience",
      para: `BA9e packages high precision brain imaging system using EEG and fNIRS to record neural activity in clinical and research environments. It uses hybrid electrodes to set a new standard of usability for researchers.`,
      button: "Coming Soon",
    },
    {
      image: "ABHA",
      heading: "ABHA",
      subHeading: "Neurological rehabilitation of tomorrow",
      para: `ABHA is an innovative and unique solution for stroke survivors that uses brain-computer interface technology and rehabilitative robotics to help the survivors regain functions and motor movements.`,
      button: "Coming Soon",
    },
  ];

  return (
    <Content
      style={{
        minHeight: 280,
        background: colorBgContainer,
        paddingTop: 0,
      }}
      className={`${ROOT}__content_body`}
    >
      <Row
        gutter={[0, 0]}
        style={{ background: colorBgContainer }}
        className="banner_ui mb-3"
      >
        <Col lg={24} xs={24} sm={24}>
          <ReferralBanner headerTitle={headerTitle} />
        </Col>
      </Row>
      <div className="px-4">
        <Row gutter={[15, 15]} className={`${ROOT}__product_card`}>
          {products?.map((item, index) => {
            return (
              <Col lg={8} sm={12} md={12} xs={24} key={index}>
                <Card style={{ height: "100%" }}>
                  {" "}
                  <img
                    src={require(`../../assets/products/${item.image}.webp`)}
                    alt={item.heading}
                    className="img-fluid"
                  />
                  <h2>{item.heading}</h2>
                  <h4>{item.subHeading}</h4>
                  <p>{item.para}</p>
                  <a href={item.link} target="_blank">
                    <Button
                      block
                      disabled={item.button === "Try Now" ? false : true}
                      className="my-card-btn border-0"
                      style={{
                        background: `${
                          item.button === "Try Now" ? "#0C8AE6" : "#EAEAEB"
                        }`,
                        color: `${item.button === "Try Now" && "white"}`,
                      }}
                    >
                      {item.button}
                    </Button>
                  </a>
                </Card>
              </Col>
            );
          })}
        </Row>
      </div>
    </Content>
  );
};

export default DashboardProducts;
